//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { TOAST_NOTIFICATIONS_ACTIONS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import {
  IPlainToast,
  IToastNotification,
} from '@legacy-components/common/toast-notifications/toastNotificationsModel';
import { createAction } from '@utils/actions';

export const toastNotificationsActions = {
  addToastNotification(toastNotification: IToastNotification) {
    return createAction({
      type: TOAST_NOTIFICATIONS_ACTIONS.ADD_TOAST_NOTIFICATION,
      toastNotification,
    });
  },

  /**
   * Shortcut to add a plain toast notification that only shows
   * a title without any success/warning/failure UI.
   */
  addPlainToastNotification(toastNotification: IPlainToast) {
    return createAction({
      type: TOAST_NOTIFICATIONS_ACTIONS.ADD_TOAST_NOTIFICATION,
      toastNotification,
    });
  },

  removeToastNotification(toastNotificationId: string) {
    return createAction({
      type: TOAST_NOTIFICATIONS_ACTIONS.REMOVE_TOAST_NOTIFICATION,
      toastNotificationId,
    });
  },

  closeToastNotification(toastNotificationId: string) {
    return createAction({
      type: TOAST_NOTIFICATIONS_ACTIONS.CLOSE_TOAST_NOTIFICATION,
      toastNotificationId,
    });
  },

  /**
   * This action removes a toast notification message from the screen.
   * Calling the action adds the notificationId to the Redux state (toastNotificationsToClose).
   * This triggers the close method in the ToastNotificationService, which removes the notification from the screen.
   * Once the notification is removed, the ToastNotificationService triggers the removeClosedToastNotification,
   * which removes the notificationId from the Redux state.
   */
  removeClosedToastNotification(toastNotificationId: string) {
    return createAction({
      type: TOAST_NOTIFICATIONS_ACTIONS.REMOVE_CLOSED_TOAST_NOTIFICATION,
      toastNotificationId,
    });
  },

  addHashtagUntrackedToastNotification(hashtag: string) {
    return toastNotificationsActions.addToastNotification({
      title: `You have successfully untracked #${hashtag}`,
    });
  },
};

export type ToastNotificationsActionType = ReturnType<
  | typeof toastNotificationsActions.addToastNotification
  | typeof toastNotificationsActions.removeToastNotification
  | typeof toastNotificationsActions.closeToastNotification
  | typeof toastNotificationsActions.removeClosedToastNotification
>;
